/**
 * Take care importing code here! This is inlined into every app via setup-theme.ts.
 */
export const MODERN_THEMES = {
  'warm-neutral-light': {
    themeName: 'warm-neutral',
    themeMode: 'light',
    legacyFallback: 'trellis-light',
  },
  'navy-light': {
    themeName: 'navy',
    themeMode: 'light',
    legacyFallback: 'trellis-light',
  },
  'lavender-light': {
    themeName: 'lavender',
    themeMode: 'light',
    legacyFallback: 'trellis-light',
  },
} as const;

export type ModernThemeKey = keyof typeof MODERN_THEMES;
